export default "__VITE_ASSET__rtpmWpX4__"